module.exports = {
    "deals": {
        "policyRenewalCompleted": null,
        "anyCurrentClaimsOnThisPolicy": null,
        "type": null,
        "dealOwner": "22106000000065307",
        "netCorporateCommissionAfterDeductible": null,
        "dealStage": null,
        "preferredContactTime": null,
        "referralSource": null,
        "dateOfClaim": null,
        "howManyMonthsLeft": null,
        "existingPolicyRenewalDueBy": null,
        "fax": null,
        "visitorScore": null,
        "totalAdvisorCommission": null,
        "areThereMultipleInsuredForThisPolicy": null,
        "insuranceLeadScoringPositiveTouchPointScore": null,
        "numberOfCharts": null,
        "insuranceLeadScoringTouchPointScore": null,
        "phone": null,
        "campaignSource": null,
        "lifeInsurance": null,
        "productCategoryReferred": null,
        "firstPageVisited": null,
        "insuranceLeadScoringNegativeTouchPointScore": null,
        "reRunRoundRobin": true,
        "status": null,
        "areThereTrusteesforThisPolicy": null,
        "claimClosedOn": null,
        "secondaryEmail": null,
        "actualPolicyCommissionAfterDeductibles": null,
        "insuranceLeadScoringScore": null,
        "investments": null,
        "claimOutcome": null,
        "isClientABeneficiary": null,
        "insurencePartner": null,
        "trustDocumentsReceivedAndUploaded": null,
        "currency": "CAD",
        "travelInsurance": null,
        "email": null,
        "locationName": null,
        "daysVisited": null,
        "claimAmount": null,
        "mostRecentVisit": null,
        "trustDissolutionDate": null,
        "stage": "Qualification",
        "advisorsId": null,
        "roundRobinProcessed": false,
        "sourceId": null,
        "averageTimeSpent": null,
        "eligibleRoundRobinOwnerFound": null,
        "numberOfContactAttempts": null,
        "isClientTheInsured": null,
        "source": "catalyst",
        "phoneBurnerLastCallTime": null,
        "combinationHybridInsurance": null,
        "exchangeRate": null,
        "insuranceLeadSource": "Advertisement",
        "numberOfTrustees": null,
        "settlementOrRejectionObservations": null,
        "firstVisit": null,
        "returnAmount": null,
        "phoneA": null,
        "nextFollowUpDateTime": null,
        "nextFollowUpDate": null,
        "contactName": null,
        "insuranceLeadScoringNegativeScore": null,
        "referralNameOthers": null,
        "loanProtection": null,
        "claimSubmitted": null,
        "name": "Test deal",
        "applicationInitiatedOn": null,
        "CREATEDTIME": "2024-08-06 09:36:01:838",
        "referralNameClient": null,
        "reasonOfClaim": null,
        "description": null,
        "anyPastClaimsOnThisPolicy": null,
        "phoneBurnerLastCallOutcome": null,
        "probabilityOfClosure": null,
        "numberOfBeneficiariesUpto4": null,
        "totalPolicyCommission": null,
        "numberOfInsured": null,
        "contactRole": null,
        "totalInteractionTime": null,
        "healthDentalInsurance": null,
        "emailOutput": null,
        "CREATORID": "22106000000069891",
        "netAdvisorCommissionAfterDeductible": null,
        "emailRoundRobinOwner": false,
        "insuranceLeadLookup": null,
        "phoneBurnerFollowUpDate": "2024-08-02",
        "amount": null,
        "insuranceLeadScoringPositiveScore": null,
        "livingBenefits": null,
        "interactionOutcome": null,
        "insuranceLead": null,
        "areThereMultipleBeneficiariesExclClient": null,
        "layout": null,
        "referrer": null,
        "MODIFIEDTIME": "2024-08-06 09:36:01:838",
        "servicesRequested": null,
        "forecastCategory": "",
        "applicationOn": null,
        "ROWID": "22106000000307387",
        "roundRobinAssignmentTime": "2024-08-02T12:00"
    },
    "contacts": {
        "lastName": null,
        "firstName": null,
        "ROWID": null
    },
    "userData": {
        "firstName": "trigya",
        "lastName": "info",
        "ROWID": "22106000000065307"
    },
    "locations": {
        "locationName": null,
        "ROWID": null
    },
    "leads": {
        "firstName": null,
        "lastName": null,
        "name": null,
        "ROWID": null
    }
}